export default "__VITE_ASSET__DiQHHTBF__"